<template>
  <div id="appointments-main" class="clearAfterFloats">
    <img
      v-if="isLoading"
      class="loading-icon"
      src="../../assets/loading-icon.gif"
      alt="Loading..."
    />
    <!-- <DIALOGS> -->
    <!-- <DATE SELECT> -->
    <v-dialog
      ref="dialog"
      v-model="dateModal"
      :return-value.sync="selectedDate"
      persistent
      lazy
      full-width
      width="290px"
    >
      <v-date-picker v-model="selectedDate" scrollable>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="dateModal = false">Cancel</v-btn>
        <v-btn flat color="primary" @click="$refs.dialog.save(selectedDate)"
          >OK</v-btn
        >
      </v-date-picker>
    </v-dialog>
    <!-- </DATE SELECT> -->
    <!-- <CREATE APPOINTMENT> -->
    <v-dialog
      v-if="createAppointmentDialog"
      v-model="createAppointmentDialog"
      :width="createDialogWidth"
    >
      <div id="createAppointmentContainer">
        <img
          @click="createAppointmentDialog = false"
          class="close-icon"
          src="../../assets/icons/close.png"
          alt="Close"
        />
        <app-create-appointment
          @showResponseMessage="showResponseMessage"
          :windowWidth="windowWidth"
          @createAppointment="createAppointment"
        ></app-create-appointment>
      </div>
    </v-dialog>
    <!-- </CREATE APPOINTMENT> -->
    <!-- <APPOINTMENT DETAILS> -->
    <v-dialog persistent :width="createDialogWidth" v-model="detailsDialog">
      <div id="details">
        <img
          @click="
            $store.commit('setDetailsDialog', false);
            $store.commit('setSelectedAppointment', null);
          "
          class="close-icon"
          src="../../assets/icons/close.png"
          alt="Close"
        />
        <app-details
          @deleteAppointment="deleteAppointment"
          :appointmentId="selectedAppointment"
        ></app-details>
      </div>
    </v-dialog>
    <!-- </APPOINTMENT DETAILS> -->
    <!-- </DIALOGS> -->
    <!-- <HEADER> -->
    <div v-if="!isLoading" class="page-header">
      <!-- <TITLE> -->
      <div v-if="windowWidth > 768" class="header-part">
        <h1 class="header-text">
          <span>
            Planer
            <div class="header-text-line"></div>
          </span>
        </h1>
      </div>
      <!-- UREDITI -->
      <!-- <v-select
        v-model="selectedStudioPage"
        :items="studioLayoutChangeDD"
        item-text="name"
        item-value="index"
        label="Odaberite stranicu"
        @change="studioListIndexChanged"
      ></v-select>-->
      <!-- UREDITI -->
      <!-- </TITLE> -->
      <!-- <DATE CHANGE> -->
      <div class="header-part header-center" v-if="appointments">
        <v-container>
          <v-layout>
            <v-flex class="d-flex" style="align-items:center;">
              <v-icon class="pointer" @click="changeDate('down')"
                >chevron_left</v-icon
              >

              <div
                style="display: flex; align-items: center; justify-content: center;"
              >
                <p v-if="appointments[0]" class="dateFromTo mb-0 text-right">
                  {{ appointments[0].Date }}
                </p>
                <span class="mx-2">-</span>
                <p v-if="appointments[2]" class="dateFromTo mb-0 text-left">
                  {{ appointments[2].Date }}
                </p>
              </div>

              <v-icon class="pointer" @click="changeDate('up')"
                >chevron_right</v-icon
              >
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <!-- </DATE CHANGE> -->
      <!-- <ACTIONS> -->
      <div class="header-part header-right">
        <p v-if="windowWidth < 768" class="dayAndDate">
          <span class="dayOfTheWeek">{{ dates[0].dayOfTheWeek + "," }}</span>
          <span class="day-date">{{ dates[0].displayDate }}</span>
        </p>

        <div>
          <img
            @click="dateModal = true"
            class="action-icon-lg"
            src="https://img.icons8.com/ios/50/000000/calendar.png"
            alt="Datum"
          />
        </div>
        <!-- <STUDIO PAGE SELECTOR> -->
        <hover-drop-down
          class="layout-change"
          :items="studioListSelector"
          :main-icon="'https://img.icons8.com/ios/50/000000/one-page.png'"
          @itemSelected="studioListIndexChanged"
        ></hover-drop-down>
        <!-- </STUDIO PAGE SELECTOR> -->

        <!-- <LAYOUT SELECTOR> -->
        <hover-drop-down
          v-if="windowWidth > 768"
          class="layout-change"
          :items="layoutSelector"
          :main-icon="
            'https://img.icons8.com/ios/50/000000/pricing-structure.png'
          "
          @itemSelected="changeLayout"
        ></hover-drop-down>
        <!-- </LAYOUT SELECTOR> -->
        <div
          v-if="
            !$store.state.services.checkRole('Portir') && !unpaidSubscription
          "
          class="createBtn"
          @click="createAppointmentDialog = true"
        >
          <v-icon id="plus-icon">add</v-icon>
        </div>
      </div>
      <!-- </ACTIONS> -->
    </div>
    <!-- <HEADER> -->
    <!-- <APPOINTMETS> -->
    <!-- IF(layoutSelected == "oneDay") -> SHOW ONE DAY -->
    <app-per-day
      v-if="
        (windowWidth < 768 || layoutOneDay) && appointments[0] && !isLoading
      "
      :windowWidth="windowWidth"
      :isLayoutOneDay="layoutOneDay"
      :appointmentsDate="appointments[0].Date"
      :day="appointments[0]"
      :dayOfTheWeek="getDayOfTheWeek(appointments[0].DayOfTheWeekIndex)"
      :studioList="studioList"
      :numberOfStudioListPages="numberOfStudioListPages"
      :selectedStudioPage="selectedStudioPage"
      @changeStudioListIndex="changeStudioListIndex"
      @newDate="changeDate"
      class="day"
      :style="{ width: '100%' }"
    ></app-per-day>

    <!-- ELSE -> SHOW THREE DAYS -->
    <div v-if="windowWidth > 768 && !layoutOneDay && !isLoading">
      <app-per-day
        v-for="(appointment, i) in appointments"
        :key="i"
        :windowWidth="windowWidth"
        :isLayoutOneDay="layoutOneDay"
        :appointmentsDate="appointment.Date"
        :day="appointment"
        :dayOfTheWeek="getDayOfTheWeek(appointment.DayOfTheWeekIndex)"
        :studioList="studioList"
        class="day"
      ></app-per-day>
    </div>
    <!-- </APPOINTMETS> -->
  </div>
</template>

<script>
import PerDay from "./PerDay";
import CreateAppointment from "./CreateNew";
import Details from "./Details";
import HoverDropDown from "../HoverDropDown";

// Event bus
import { bus } from "../../main";
export default {
  components: {
    appPerDay: PerDay,
    appCreateAppointment: CreateAppointment,
    hoverDropDown: HoverDropDown,
    appDetails: Details,
  },
  data() {
    return {
      appointments: [],
      windowWidth: 0,
      // responseMessage:"",
      responseMessage: {
        IsError: false,
        Message: "",
      },
      responseMessageActive: false,
      dates: [],
      selectedDate: null,
      dateModal: false,

      createAppointmentDialog: false,
      isAppointmentCreate: true,
      createDialogWidth: "100%",

      //Layout selector
      layoutOneDay: false,
      layoutSelector: [
        {
          text: "One day",
          value: "oneDay",
          icon: "view_column",
        },
        {
          text: "Three days",
          value: "threeDays",
          icon: "view_carousel",
        },
      ],
      studioListSelector: [],
      //For displaying day name in Bosnian
      daysOfTheWeek: [],
      detailsDialog: false,

      studioLayoutChangeDD: [],
      selectedStudioPage: 0,
      studioList: [],
      numberOfStudioListPages: 0,
      isLoading: false,
    };
  },
  computed: {
    selectedAppointment() {
      return this.$store.getters.getSelectedAppointment;
    },
    detailsDialogComp: {
      get: function() {
        this.detailsDialog = this.$store.getters.getDetailsDialog;
      },
      set: function(val) {
        this.detailsDialog = val;
      },
    },
    unpaidSubscription() {
      return localStorage.getItem("unpaid-subscription") === "unpaid";
    },
  },
  watch: {
    selectedDate(val) {
      this.dialog = false;
      this.createDates(val);
      this.setAppointments();
      if (this.windowWidth > 768) {
        this.getAppointments();
      } else {
        this.isLoading = true;
        this.getAppointmentsSingle()
          .then((res) => {
            // Event bus $emit
            bus.$emit("ebDateChanged");
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    detailsDialogComp(val) {
      this.detailsDialog = val;
    },
    detailsDialog(val) {
      if (val == false) this.$store.commit("setDetailsDialog", false);
    },
  },
  methods: {
    getAppointments() {
      this.isLoading = true;
      this.$store.state.services.appointmentService
        .getByDateAndStudioListIndex(
          this.dates[0].date,
          this.selectedStudioPage,
          localStorage.getItem("user"),
        )
        .then((res) => {
          this.appointments = res.data;
        })
        .finally(() => {
          this.isLoading = false;
          let userToken = localStorage.getItem("user-token");
          if(userToken){
            this.getUserData(userToken);
          }
        });
    },
    getAppointmentsSingle() {
      let self = this;
      this.isLoading = true;
      return new Promise(function(resolve, reject) {
        self.$store.state.services.appointmentService
          .getByDateAndStudioListIndexSingle(
            self.dates[0].date,
            self.selectedStudioPage,
            localStorage.getItem("user"),
          )
          .then((res) => {
            self.appointments = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getUserData(token) {
      this.$store.state.services.authService.getData(token).then((result) => {
        if (
          result.data.UserRoles.length === 1 &&
          result.data.UserRoles.includes("Polaznik") &&
          result.data.HasPaidSubscription
        ) {
          localStorage.removeItem("unpaid-subscription");
        }
      });
    },
    setAppointments() {
      //Setting appointments based on selected date -> getting selected date day + 2 upper days
      this.$store.dispatch("setAppointments", this.dates[0].date);
    },
    /* GETTERS */
    getDaysOfTheWeek() {
      //Getting day names in Bosnian
      this.daysOfTheWeek = this.$store.getters.getDaysOfTheWeek;
    },
    getWindowWidth(event) {
      //Tracking window width for showing/hiding elements based on it
      this.windowWidth = document.documentElement.clientWidth;
    },
    getDayOfTheWeek(dayIndex) {
      return this.daysOfTheWeek.find((x) => x.Value == dayIndex).Name;
    },
    createStudioLayoutChangeDD() {
      this.$store.state.services.studioService.DDItemsCount().then((res) => {
        var i = 0;
        this.numberOfStudioListPages = res.data;
        for (i; i < res.data; i++) {
          this.studioLayoutChangeDD.push({
            index: i,
            name: "Stranica " + (i + 1),
          });
          this.studioListSelector.push({
            text: "Studio list " + (i + 1),
            value: i,
          });
        }
      });
    },
    /* HELPERS */
    changeLayout(value) {
      //Changing layout view from one day to three days and vice versa
      if (value == "oneDay") {
        this.layoutOneDay = true;
      } else {
        this.layoutOneDay = false;
      }
    },
    changeDate(upOrDown) {
      //Changing date up or down and triggering setAppointments methods based on new date
      if (upOrDown == "up") {
        if (this.selectedDate != null) {
          this.selectedDate = this.addDays(this.selectedDate, 1);
        } else {
          this.selectedDate = this.addDays(new Date(), 1);
        }
      } else {
        if (this.selectedDate != null) {
          this.selectedDate = this.addDays(this.selectedDate, -1);
        } else {
          this.selectedDate = this.addDays(new Date(), -1);
        }
      }
      // WARNING - maybe will have to be removed
      this.selectedDate = this.$moment(this.selectedDate).format("YYYY-MM-DD");
    },
    addDays(date, days) {
      //Helper function for adding days to parsed date for number parsed value
      var result = new Date(date);

      result.setDate(result.getDate() + days);
      return result;
    },
    createDates(d) {
      //Filling dates array which will be used in every place where any date is needed
      this.dates = [];
      var i = 0;
      for (i; i < 3; i++) {
        var newDate = {
          date: this.$moment(this.addDays(d, i)).format("MM-DD-YYYY"),
          displayDate: this.$moment(this.addDays(d, i)).format("DD.MM.YYYY"),
          dayOfTheWeek: this.getDayOfTheWeek(this.addDays(d, i).getDay()),
        };
        this.dates.push(newDate);
      }
    },
    showResponseMessage(response) {
      this.$store.dispatch("setResponseMessage", response);
    },
    /* APPOINTMENT POST */
    createAppointment() {
      //Object parsed from child component triggered by creation of new appointment
      this.createAppointmentDialog = false;
      // this.setAppointments();
      this.getAppointments();
    },
    deleteAppointment(response) {
      this.detailsDialog = false;
      this.showResponseMessage(response);
      this.setAppointments();
      this.getAppointments();
    },
    studioListIndexChanged(index, action) {
      if (this.selectedStudioPage === index) {
        return;
      }
      if (!action) {
        if (this.selectedStudioPage < index) {
          action = "add";
        } else {
          action = "subtract";
        }
      }
      this.selectedStudioPage = index;
      this.getStudioListByIndex();
      if (this.windowWidth > 768) {
        this.getAppointments();
      } else {
        this.isLoading = true;
        this.getAppointmentsSingle()
          .then((res) => {
            // Event bus $emit
            bus.$emit("ebStudioListIndexChanged", action);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    changeStudioListIndex(action) {
      if (action === "add") {
        this.studioListIndexChanged(this.selectedStudioPage + 1, "add");
      } else {
        this.studioListIndexChanged(this.selectedStudioPage - 1, "subtract");
      }
    },
    getStudioListByIndex() {
      this.$store.state.services.studioService
        .getByListIndex(this.selectedStudioPage)
        .then((res) => {
          this.studioList = res.data;
        });
    },
  },
  created() {
    //Initial function calls
    var d = new Date();
    this.getDaysOfTheWeek();
    this.createDates(d);
    this.getStudioListByIndex();
    this.createStudioLayoutChangeDD();
  },
  mounted() {
    //Tracking window width
    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowWidth);
      this.getWindowWidth();
      if (this.windowWidth > 768) {
        this.createDialogWidth = "70%";
        this.getAppointments();
      } else {
        this.createDialogWidth = "100%";
        this.isLoading = true;
        this.getAppointmentsSingle().finally(() => {
          this.isLoading = false;
        });
      }
    });
  },
  beforeDestroy() {
    //Removing event listener on resize after component has been destroyed
    window.removeEventListener("resize", this.getWindowWidth);
  },
};
</script>

<style scoped>
#appointmentsMain {
  position: relative;
}
#createAppointmentContainer {
  background-color: white;
  padding: 25px;
  position: relative;
}
.loading-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#details {
  position: relative;
}

.day {
  width: calc(33.3% - 20px);
  float: left;
}

.dayOfTheWeek {
  font-size: 18px;
  padding-left: 4px;
  border-left: 2px solid #039be5;
}
.dayAndDate {
  display: inline-block;
}
.day-date {
  font-size: 14px;
  font-weight: 300;
}

#datePickerIcon {
  font-size: 42px;
  cursor: pointer;
  height: 100%;
}
.layout-change {
  display: inline-block;
  font-size: 42px;
  height: 100%;
}

#dialog {
  text-align: center;
}

.createBtn {
  width: 56px;
  height: 56px;
  padding: 0;
  margin: 0;
  position: fixed;
  z-index: 4;
  bottom: 20px;
  right: 20px;
  background-color: #039be5;
  border-radius: 50%;
  cursor: pointer;
}

.dateFromTo {
  display: inline-block;
  vertical-align: top;
  line-height: 40px;
}

.pointer {
  margin: 0 15px;
  font-size: 40px;
  color: #039be5;
}

.createBtn:hover {
  background-color: #017dba;
  transition: 0.3s;
}

.createBtn #plus-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}

/* APPOINTMENT CREATE */
#createAppointmentContainer {
  position: relative;
}

/* RESPONSE MESSAGE */
.responseMessage {
  padding: 10px 10px;
  position: fixed;
  left: 20px;
  bottom: -100px;
  background-color: white;
  z-index: 3;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  animation: messageFadeIn 10s;
}
.responseMessage span {
  display: inline-block;
  vertical-align: top;
  line-height: 25px;
  margin: 0 5px;
}
.responseMessage img {
  width: 25px;
}
.responseMessage img:nth-child(3) {
  cursor: pointer;
  width: 20px;
}
.responseMessage-success {
  border-left: 2px solid #2ecc71;
}
.responseMessage-error {
  border-left: 2px solid #e74c3c;
}
@keyframes messageFadeIn {
  0% {
    bottom: -100px;
  }
  15% {
    bottom: 20px;
  }
  85% {
    bottom: 20px;
  }
  100% {
    bottom: -100px;
  }
}
.header-right {
  align-items: stretch;
  gap: 15px;
}
.header-right > div:not(.createBtn) {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  align-self: center;
}

/* MOBILE */
@media (max-width: 768px) {
  .day {
    width: 100%;
  }
  .date-mobile {
    float: right;
    width: 25px;
  }
  .header-center {
    display: none;
  }
  .header-right {
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .header-right p {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    justify-content: flex-start;
    flex: 1;
    margin: 0;
  }

  .header-right > div:not(.createBtn) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    align-self: center;
  }

  #datePickerIcon {
    float: right;
    font-size: 32px;
  }
}
</style>
<style>
.header-right img {
  margin: 0;
}
</style>
